// Percorso file: src/pages/home/AustraliaGoalButton.jsx
//
// IL BOTTONE «AUSTRALIA GOAL» DELLA SQUADRA (cantiere TEAM-LINK) — apre,
// in scheda nuova, la pagina di Australia Goal di UNA squadra: calendario,
// classifica, statistiche.
//
// Sta in `pages/home/` e non in `components/` per la stessa ragione scritta
// in testa a EnrolNextSeason.jsx, che è il calco di questo file: lo montano
// SOLO le home (player, minore, coach), e mettere fra i componenti una cosa
// che serve a tre pagine sorelle avrebbe creato una dipendenza
// `components/ → pages/` senza guadagnarci nulla.
//
// ⚠️ NIENTE LINK, NIENTE BOTTONE, E LA REGOLA STA QUI. Il campo `link` è
// una stringa sul documento squadra e non tutte le squadre ce l'hanno: la
// guardia `if (!link) return null` vive dentro il componente, una volta
// sola, così nessuna delle tre home deve ricordarsene. È lo stesso modo di
// EnrolNextSeason («si mostra da sé») e di PastigliaCategoriaSeNota («se
// non è nota, taci»).
//
// ⚠️ IL LINK NON SI CERCA QUI, ed è una scelta di disegno, non una
// dimenticanza. Ogni home la squadra la trova già per conto suo — Player e
// Child con lo stesso `find` che riempie la pastiglia della categoria, il
// coach dalla mappa costruita sulla risposta di `GET /teams` — e spostare
// quella ricerca dentro il componente gli farebbe attraversare dati
// (`contexts`, l'anno operativo, l'elenco delle squadre) che oggi le pagine
// non gli passano. Qui arriva il link già trovato, e nient'altro.
//
// ⚠️ IL LOGO SI IMPORTA, non si scrive per URL. Il banner in coda alle home
// (`/assets/footer%20AG.png`) è servito da `public/` e referenziato con un
// percorso assoluto codificato, perché il file ha uno spazio nel nome:
// QUI si fa apposta diversamente. `ag-logo.png` sta in `src/assets/`, il
// nome non ha spazi, e l'import lo fa passare dal bundler come per
// `avatar-placeholder.png` (UsersList.jsx, MemberProfileModal.jsx,
// EditMemberModal.jsx) — così il percorso non si scrive a mano e un file
// spostato o rinominato rompe la build invece di rompere la pagina.
//
// ⚠️ È UN LINK ESTERNO, con la forma dello Shop: `target="_blank"` e
// `rel="noopener noreferrer"`. Non è una voce di rotta dell'app: è il link
// che l'admin imposta per la squadra. Le tre home lo montano DENTRO il
// `<nav className="qpsc-menu">` delle voci, sotto la riga della squadra (il
// secondo `<nav>` in HomePlayer e HomeCoach, l'unico in HomeChild): fra
// My Attendance e Clinic nel giocatore e nel minore, in coda alle voci di
// squadra nel coach.
//
// COSA NON FA — confini della fetta, non omissioni:
//   · non valida l'indirizzo e non lo normalizza: il `link` è quello che
//     l'assegnazione ha scritto sul documento squadra, e il metro di
//     scrittura è di quella sede;
//   · non dice di CHE squadra sia: il nome sta già nella riga sopra, in
//     tutte e tre le home.

import React from "react";
import agLogo from "../../assets/ag-logo.png";
import "./AustraliaGoalButton.css";

const AustraliaGoalButton = ({ link }) => {
  // La regola in una riga: senza indirizzo non c'è niente da aprire, e un
  // bottone che non porta da nessuna parte è peggio di nessun bottone.
  if (!link) return null;

  return (
    <a
      className="qpsc-btn-ag"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="qpsc-btn-ag__icon">
        <img src={agLogo} alt="Australia Goal" />
      </span>
      Team Fixtures / Ladder / Stats
    </a>
  );
};

export default AustraliaGoalButton;
